import * as React from 'react';

import { Select, Row, Col } from 'antd';
const { Option } = Select;
import { IWidget } from 'common/schema/widget/Widget';
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { SelectInput } from 'client/ui/form/input/SelectInput';
import comuni from 'common/comuni.json';
import { useFormikContext, getIn } from 'formik';
import { IRequest } from 'common/schema/request/Request';
import { useFormikFieldChange } from 'client/ui/form/hooks/useFormikFieldChange';
import { useFormWidgetProps } from './contextual/useFormWidgetProps';
import { getProvinceStructure } from 'common/schema/widget/provinces/getProvinceStructure';
import { TextInput } from 'client/ui/form/input/TextInput';

/**
 * Constante per gestire la selezione dello stato estero
 */
const STATO_ESTERO_EE = 'Stato Estero (EE)';

export interface FormWidgetInputRegionViewProps {
  widget: IWidget;
}

// TODO Gestire placeholder diversi lato `Setup` con `input.extra`
export function FormWidgetInputRegionView(
  props: FormWidgetInputRegionViewProps
) {
  const { widget } = props;
  const formik = useFormikContext<IRequest>();

  // Aggiunto Stato Estero (EE) alla lista delle province
  const province = getProvinceStructure(comuni).concat({
    nome: STATO_ESTERO_EE,
    sigla: 'EE',
    comuni: []
  });

  const [provincia, comune] = MetadataLogic.multipleFromWidget(widget, [
    'provincia',
    'comune'
  ]);
  const [provinciaName, comuneName] = [
    `values.${provincia.id}`,
    `values.${comune.id}`
  ];

  const [provinciaInputProps, comuneInputProps] = useFormWidgetProps(widget, [
    'provincia',
    'comune'
  ]);

  useFormikFieldChange(
    formik => {
      formik.setFieldValue(comuneName, undefined);
    },
    [provinciaName]
  );

  const provinciaValue = getIn(formik.values, provinciaName);

  return (
    <FormWidgetItem names={[provinciaName, comuneName]} widget={props.widget}>
      <Row gutter={6}>
        <Col span={12}>
          <SelectInput
            name={provinciaName}
            placeholder="Provincia"
            showSearch
            autoComplete={'stop-the-address-autocomplete'}
            {...provinciaInputProps}
          >
            {province.map(option => (
              <Option key={option.sigla} value={option.nome}>
                {option.nome}
              </Option>
            ))}
          </SelectInput>
        </Col>
        <Col span={12}>
          {/*  Se ho selezionato Stato Estero (EE) da SelectInput diventa TextInput */}
          {provinciaValue && provinciaValue === STATO_ESTERO_EE ? (
            <TextInput
              name={comuneName}
              placeholder={STATO_ESTERO_EE}
              {...comuneInputProps}
            />
          ) : (
            <SelectInput
              name={comuneName}
              placeholder="Comune"
              showSearch
              {...comuneInputProps}
            >
              {provinciaValue &&
                province
                  .find(p => p.nome === provinciaValue)!
                  .comuni.map(option => (
                    <Option key={option.nome} value={option.nome}>
                      {option.nome}
                    </Option>
                  ))}
            </SelectInput>
          )}
        </Col>
      </Row>
    </FormWidgetItem>
  );
}
